// @flow
import add from './add.svg';
import addCircle from './add-circle.svg';
import addPin from './add-pin.svg';
import angledPin from './angled-pin.svg';
import arrowBack from './arrow-back.svg';
import arrowCircleForward from './arrow-circle-forward.svg';
import arrowCircleDown from './arrow-circle-down.svg';
import arrowDown from './arrow-down.svg';
import arrowForward from './arrow-forward.svg';
import arrowUp from './arrow-up.svg';
import arrowUpRight from './arrow-up-right.svg';
import bell from './bell.svg';
import camera from './camera.svg';
import cameraRoll from './camera-roll.svg';
import cancel from './cancel.svg';
import check from './check.svg';
import checkCircle from './check-circle.svg';
import circleOutline from './circle-outline.svg';
import clear from './clear.svg';
import clock from './clock.svg';
import cog from './cog.svg';
import compass from './compass.svg';
import dash from './dash.svg';
import edit from './edit.svg';
import ellipsis from './ellipsis.svg';
import ellipsisCircleOutline from './ellipsis-circle-outline.svg';
import envelope from './envelope.svg';
import eye from './eye.svg';
import facebook from './facebook.svg';
import faceHappy from './face-happy.svg';
import faceSad from './face-sad.svg';
import faceSmiley from './face-smiley.svg';
import filter from './filter.svg';
import flag from './flag.svg';
import flashlight from './flashlight.svg';
import gif from './gif.svg';
import globe from './globe.svg';
import globeChecked from './globe-checked.svg';
import gmail from './gmail.svg';
import googlePlus from './google-plus.svg';
import graphBar from './graph-bar.svg';
import knoop from './knoop.svg';
import lightbulb from './lightbulb.svg';
import handle from './handle.svg';
import handPointing from './hand-pointing.svg';
import heart from './heart.svg';
import heartBroken from './heart-broken.svg';
import link from './link.svg';
import location from './location.svg';
import lock from './lock.svg';
import maximize from './maximize.svg';
import megaphone from './megaphone.svg';
import menu from './menu.svg';
import minimize from './minimize.svg';
import move from './move.svg';
import mute from './mute.svg';
import pause from './pause.svg';
import people from './people.svg';
import person from './person.svg';
import personAdd from './person-add.svg';
import pin from './pin.svg';
import pinHide from './pin-hide.svg';
import pinterest from './pinterest.svg';
import play from './play.svg';
import questionMark from './question-mark.svg';
import remove from './remove.svg';
import report from './report.svg';
import search from './search.svg';
import send from './send.svg';
import share from './share.svg';
import shoppingBag from './shopping-bag.svg';
import smiley from './smiley.svg';
import smileyOutline from './smiley-outline.svg';
import sound from './sound.svg';
import speech from './speech.svg';
import speechEllipsis from './speech-ellipsis.svg';
import tag from './tag.svg';
import twitter from './twitter.svg';
import viewTypeDefault from './view-type-default.svg';
import viewTypeDense from './view-type-dense.svg';
import viewTypeList from './view-type-list.svg';

export default {
  add,
  'add-circle': addCircle,
  'add-pin': addPin,
  'angled-pin': angledPin,
  'arrow-back': arrowBack,
  'arrow-circle-down': arrowCircleDown,
  'arrow-circle-forward': arrowCircleForward,
  'arrow-down': arrowDown,
  'arrow-forward': arrowForward,
  'arrow-up': arrowUp,
  'arrow-up-right': arrowUpRight,
  bell,
  camera,
  'camera-roll': cameraRoll,
  cancel,
  check,
  'check-circle': checkCircle,
  'circle-outline': circleOutline,
  clear,
  clock,
  cog,
  compass,
  dash,
  edit,
  ellipsis,
  'ellipsis-circle-outline': ellipsisCircleOutline,
  envelope,
  eye,
  facebook,
  'face-happy': faceHappy,
  'face-sad': faceSad,
  'face-smiley': faceSmiley,
  filter,
  flag,
  flashlight,
  gif,
  globe,
  'globe-checked': globeChecked,
  gmail,
  'google-plus': googlePlus,
  'graph-bar': graphBar,
  handle,
  'hand-pointing': handPointing,
  heart,
  'heart-broken': heartBroken,
  knoop,
  lightbulb,
  link,
  location,
  lock,
  maximize,
  megaphone,
  menu,
  minimize,
  move,
  mute,
  pause,
  people,
  person,
  'person-add': personAdd,
  pin,
  'pin-hide': pinHide,
  pinterest,
  play,
  'question-mark': questionMark,
  remove,
  report,
  search,
  'shopping-bag': shoppingBag,
  smiley,
  'smiley-outline': smileyOutline,
  send,
  share,
  sound,
  speech,
  'speech-ellipsis': speechEllipsis,
  tag,
  twitter,
  'view-type-default': viewTypeDefault,
  'view-type-dense': viewTypeDense,
  'view-type-list': viewTypeList,
};
